import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
export default function Enterpriseresourceplanning() {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  const primaryColor = "#684df4";

  // Reusable hover logic (updated to also handle border color)
  const onHover = (e) => {
    e.currentTarget.style.background = primaryColor;
    e.currentTarget.style.color = '#ffffff';
    e.currentTarget.style.transform = 'translateY(-8px) scale(1.025)';
    e.currentTarget.style.boxShadow = '0 20px 50px rgba(0,0,0,0.18)';
    e.currentTarget.style.borderColor = primaryColor;
    const icon = e.currentTarget.querySelector('i');
    if (icon) icon.style.color = '#ffffff';
  };

  const onLeave = (e) => {
    e.currentTarget.style.background = 'white';
    e.currentTarget.style.color = 'inherit';
    e.currentTarget.style.transform = 'translateY(0) scale(1)';
    e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.08)';
    e.currentTarget.style.borderColor = '#a0a0a0';
    const icon = e.currentTarget.querySelector('i');
    if (icon) icon.style.color = primaryColor;
  };

  return (
    <div>
      <Helmet>
        <title>Intelligent ERP Software In Pakistan - Technic Mentors</title>
        <link rel="canonical" href="https://technicmentors.com/business-management-solutions" />
      </Helmet>

      {/* Hero Header */}
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
             CapoBiz - Business Management Solution
            </h1>
          </div>
        </div>
      </div>

      {/* Introduction */}
      <div className="container mt-5">
        <div className="section-title text-center">
          <h2>Manage Every Aspect Of Your Business</h2>
          <h3>
             <span> CapoBiz - Enterprise Resource Planning System</span>
          </h3>
        </div>
        <p style={{ textAlign: "justify" }}>
          We offer a full range of value-added and intelligent ERP accounting software and
          Customer Relationship Management services for customers with new and
          existing solution deployments. We provide smart strategy and planning,
          design and architecture, implementation and optimization, and
          maintenance and support capabilities under one roof, giving our
          customers high flexibility, excellent value, and complete peace of
          mind.
        </p>
        <p>
          Our experts recommend the best ERP accounting software in Pakistan, manufacturing
          ERP software and CRM solutions for your unique business needs and
          enhance these solutions using industry-specialized extensions that
          drive efficiency, generate valuable insights, and save time. Having
          prior experience in working with ERPs makes us the best ERP solution
          providers in the world.
        </p>
      </div>

      {/* Small Feature Cards */}
      <div className="container mb-2" data-aos="fade-up" data-aos-duration="1000">
        <div className="row g-4">
          {[
            { icon: "fa-coins", title: "Finance Management" },
            { icon: "fa-headset", title: "CRM" },
            { icon: "fa-bullhorn", title: "Sales & Marketing" },
            { icon: "fa-people-carry-box", title: "HR Management" },
            { icon: "fa-industry", title: "Manufacturing" },
            { icon: "fa-link", title: "Supply Chain" },
            { icon: "fa-user-tie", title: "Business Intelligence" },
            { icon: "fa-warehouse", title: "Inventory Management" },
            { icon: "fa-cart-shopping", title: "Purchasing" },
            { icon: "fa-circle-nodes", title: "Process Control" }
          ].map((item, i) => (
            <div className="col-md-4" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
              >
                <div className="card-body d-flex align-items-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-lg me-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <p className="card-title mb-0">{item.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-5 mb-4" style={{ textAlign: "justify" }}>
          Our ERP Solutions redefine what's possible, offering a tailored approach that aligns with your unique business needs. Experience a harmonized ecosystem where data flows effortlessly, empowering you to make informed decisions in real-time. Elevate your enterprise with a solution designed for scalability, adaptability, and future-proof success. Your journey to operational excellence begins here – where innovation meets practicality, and your business aspirations become reality. Embrace the future of enterprise management with Technic Mentors' ERP Solutions.
        </p>
        <p style={{ textAlign: "justify" }}>
          Unlock the full potential of your business with Technic Mentors' ERP Solutions, designed to streamline operations and drive efficiency across every department. From finance and HR to supply chain and sales, our integrated platform centralizes your processes, enhancing collaboration and ensuring data accuracy. With customizable modules, our ERP adapts as your business evolves, scaling with your growth and supporting your long-term goals. Gain a competitive edge with real-time analytics and insights that empower proactive decision-making. Technic Mentors' ERP Solutions are not just tools—they're catalysts for sustainable success and transformative business outcomes.
        </p>
      </div>

      {/* Significance of ERP for Large Enterprises */}
      <div className="container my-5" data-aos="fade-up">
        <div className="row align-items-center">
          <div className="col-md-7">
            <div className="section-title text-start">
              <h3>
                The Significance of{" "}
                <span>ERP Accounting Software for Large Enterprises</span>
              </h3>
            </div>
            <p style={{ textAlign: "justify" }}>
              ERP solutions, specifically tailored for large enterprises, plays
              a pivotal role in their financial management and overall
              operations. These sophisticated solutions are of paramount
              importance for large organizations as they facilitate streamlined,
              real-time financial data management across multiple departments
              and locations. Large enterprises deal with complex financial
              transactions, extensive supply chains, and diverse revenue
              streams, and ERP accounting software helps them consolidate and
              standardize their financial processes.
            </p>
            <p style={{ textAlign: "justify" }}>
              By providing a holistic view of financial data, these systems
              enable informed decision-making, aiding in cost control, revenue
              optimization, and risk management. Moreover, an ERP software
              ensures compliance with ever-evolving financial regulations and
              standards, safeguarding the organization’s{" "}
              <a
                href="https://urdustem.com/use-of-fraud-detection-software-to-safeguard-organizations-from-financial-losses/"
                target="_blank"
                rel="noopener"
                style={{ textDecoration: "none" }}
              >
                financial integrity
              </a>
              . Ultimately, for large enterprises, an ERP solution is an
              indispensable tool to enhance operational efficiency, maintain
              financial transparency, and achieve sustainable growth in a competitive business landscape.
            </p>
          </div>

          <div className="col-md-5">
            <img
              src="assets/img/erp1.png"
              alt="erp-accounting-software"
              className="img-fluid "
            />
          </div>
        </div>
      </div>

      {/* Who Is CapoBiz For? */}
      <div className="container my-5" data-aos="fade-up" data-aos-duration="1000">
        <div className="section-title text-center mb-1">
          <h3>Who Is CapoBiz For?</h3>
          <p className="lead mt-3" style={{ color: "#555" }}>
            CapoBiz ERP is built for organizations that need complete control, visibility, and scalability across their business operations.
          </p>
        </div>
        <div className="row g-4">
          {[
            { icon: "fa-building", text: "Small to Large Enterprises – Centralize operations and scale effortlessly." },
            { icon: "fa-industry", text: "Manufacturing Companies – Manage production, inventory, and supply chains efficiently." },
            { icon: "fa-store", text: "Retail & Wholesale Businesses – Track sales, inventory, purchasing, and customer relationships." },
            { icon: "fa-handshake", text: "Service-Based Companies – Manage clients, invoicing, and operations seamlessly." },
            { icon: "fa-chart-line", text: "Finance & Operations Teams – Gain real-time financial insights and reporting." },
            { icon: "fa-user-tie", text: "Executives & Decision Makers – Make data-driven decisions with confidence." }
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
              >
                <i
                  className={`fa-solid ${item.icon} fa-2x mb-3`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <p className="mb-0 fw-medium">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Key ERP Modules Explained */}
      <div className="container my-5" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
        <div className="section-title text-center mb-2">
          <h3>Key ERP Modules Explained</h3>
        </div>
        <div className="row g-4">
          {[
            { icon: "fa-coins", title: "Finance & Accounting Management", desc: "Manage expenses, income, budgeting, invoicing, and financial reporting with accuracy and compliance." },
            { icon: "fa-handshake-angle", title: "Customer Relationship Management (CRM)", desc: "Track leads, manage customers, monitor sales pipelines, and improve client engagement." },
            { icon: "fa-bullhorn", title: "Sales & Marketing", desc: "Optimize sales workflows, automate marketing processes, and analyze performance metrics." },
            { icon: "fa-users-gear", title: "Human Resource Management (HRM)", desc: "Handle employee records, payroll, attendance, roles, and performance management efficiently." },
            { icon: "fa-warehouse", title: "Inventory Management", desc: "Monitor stock levels, warehouse operations, product movement, and inventory optimization." },
            { icon: "fa-industry", title: "Manufacturing & Process Control", desc: "Plan production cycles, monitor processes, manage resources, and reduce operational waste." },
            { icon: "fa-link", title: "Supply Chain Management", desc: "Coordinate suppliers, logistics, procurement, and distribution for smooth operations." },
            { icon: "fa-cart-shopping", title: "Purchasing Management", desc: "Automate purchase orders, supplier management, approvals, and cost tracking." },
            { icon: "fa-chart-bar", title: "Business Intelligence & Reporting", desc: "Generate real-time analytics, dashboards, and actionable insights across departments." }
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
              >
                <div className="card-body text-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-2x mb-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <h5 className="card-title mb-3">{item.title}</h5>
                  <p className="card-text small">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose CapoBiz ERP? */}
      <div className="container my-2 py-2" data-aos="fade-up" style={{ background: `rgba(104, 77, 244, 0.03)` }}>
        <div className="section-title text-center mb-2">
          <h3>Why Choose CapoBiz ERP?</h3>
        </div>
        <div className="row g-4 justify-content-center">
          {[
            { icon: "fa-layer-group", text: "All-in-One ERP Platform – One system for finance, HR, CRM, inventory, and operations." },
            { icon: "fa-server", text: "Enterprise-Grade Architecture – Designed for performance, reliability, and scalability." },
            { icon: "fa-clock-rotate-left", text: "Real-Time Data Access – Get instant insights across all departments." },
            { icon: "fa-cogs", text: "Customizable Modules – Tailored solutions for industry-specific needs." },
            { icon: "fa-bolt", text: "Improved Efficiency – Eliminate manual processes and data duplication." },
            { icon: "fa-coins", text: "Cost Optimization – Reduce operational costs and increase productivity." }
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
              >
                <i
                  className={`fa-solid ${item.icon} fa-2x mb-3`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <p className="mb-0 fw-medium">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Security & Compliance */}
      <div className="container my-1" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
        <div className="section-title text-center mb-2">
          <h3>Security & Compliance</h3>
          <p className="lead">CapoBiz ensures your enterprise data remains secure and compliant:</p>
        </div>
        <div className="row g-4">
          {[
            { icon: "fa-user-lock", text: "Role-Based Access Control – Restrict access based on user roles." },
            { icon: "fa-key", text: "Secure Authentication – Encrypted login and session management." },
            { icon: "fa-lock", text: "Data Encryption – Protects sensitive financial and customer data." },
            { icon: "fa-database", text: "Regular Backups – Ensures business continuity and disaster recovery." },
            { icon: "fa-shield-check", text: "Compliance-Ready Framework – Supports regulatory and audit requirements." },
            { icon: "fa-search", text: "System Monitoring – Continuous monitoring to prevent unauthorized access." }
          ].map((item, i) => (
            <div className="col-md-6" key={i}>
              <div
                className="card shadow-sm h-100"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                }}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
              >
                <div className="card-body d-flex align-items-center p-4">
                  <i
                    className={`fa-solid ${item.icon} fa-lg me-3`}
                    style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                  ></i>
                  <p className="mb-0">{item.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Business Benefits – short cards with icons */}
      <div className="container my-5" data-aos="fade-up">
        <div className="section-title text-center mb-2">
          <h3>Business Benefits of Using CapoBiz ERP</h3>
        </div>
        <div className="row g-4 justify-content-center">
          {[
            { icon: "fa-rocket", text: "Streamlined operations across all departments" },
            { icon: "fa-eye", text: "Centralized data with complete transparency" },
            { icon: "fa-brain", text: "Faster and smarter decision-making" },
            { icon: "fa-ban", text: "Reduced manual errors and paperwork" },
            { icon: "fa-users-rectangle", text: "Improved collaboration between teams" },
            { icon: "fa-chart-line", text: "Scalable solution that grows with your business" }
          ].map((item, i) => (
            <div className="col-md-6 col-lg-4" key={i}>
              <div
                className="card shadow-sm h-100 text-center p-4"
                style={{
                  transition: 'all 0.28s ease',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  border: '1px solid #a0a0a0',
                  backgroundColor: '#ffffff',
                  minHeight: '140px',
                }}
                onMouseEnter={onHover}
                onMouseLeave={onLeave}
              >
                <i
                  className={`fa-solid ${item.icon} fa-2x mb-3`}
                  style={{ color: primaryColor, transition: 'color 0.28s ease' }}
                ></i>
                <p className="mb-0 fw-medium px-2" style={{ fontSize: '0.95rem' }}>
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Demo Link + Credentials */}
      <div className="m-1 p-2" style={{ textAlign: "center" }}>
    

        {/* Credentials (only for POS demo) */}
   {/* Demo Link + Credentials */}
<div className="m-1 p-2" style={{ textAlign: "center" }}>
  <div className="d-flex flex-column flex-sm-row justify-content-center gap-4 mb-4">
    {/* POS Demo Button */}
    <a
      href="https://pos.technicmentors.com"
      target="_blank"
      rel="noopener noreferrer"
      className="btn"
      style={{
        backgroundColor: "#684df4",
        color: "white",
        padding: "12px 32px",
        borderRadius: "8px",
        fontSize: "1.1rem",
        fontWeight: "600",
        textDecoration: "none",
        boxShadow: "0 4px 15px rgba(104, 77, 244, 0.25)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 10px 25px rgba(104, 77, 244, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(104, 77, 244, 0.25)";
      }}
    >
      Try Live Demo →
    </a>

    {/* Visit Site Button */}
    <a
      href="https://capobiz.com/"
      target="_blank"
      rel="noopener noreferrer"
      className="btn"
      style={{
        backgroundColor: "transparent",
        color: "#684df4",
        border: "2px solid #684df4",
        padding: "12px 32px",
        borderRadius: "8px",
        fontSize: "1.1rem",
        fontWeight: "600",
        textDecoration: "none",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#684df4";
        e.currentTarget.style.color = "white";
        e.currentTarget.style.transform = "translateY(-3px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
        e.currentTarget.style.color = "#684df4";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      Visit CapoBiz Site →
    </a>
  </div>

  {/* Credentials */}
  <div style={{ fontSize: "1.05rem", color: "#444", marginTop: "1rem" }}>
    <strong>Username:</strong> pos@technicmentors.com<br />
    <strong>Password:</strong> 12345678
  </div>
</div>

{/* Restaurant Management System CTA */}
<div className="container my-5 text-center" data-aos="fade-up">
  <div
    className="p-5"
    style={{
      background: "linear-gradient(135deg, rgba(104,77,244,0.08), rgba(104,77,244,0.03))",
      borderRadius: "16px",
      border: "1px solid rgba(104,77,244,0.2)",
    }}
  >
    <i
      className="fa-solid fa-utensils fa-3x mb-4"
      style={{ color: "#684df4" }}
    ></i>
    <h3 className="mb-3">Also Explore Our Restaurant Management System</h3>
    <p className="lead mb-4" style={{ color: "#555" }}>
      A complete solution tailored for restaurants — manage orders, tables,
      billing, kitchen operations, and more from one platform.
    </p>
    <Link
      to="/restuarent-management-system"
      className="btn"
      style={{
        backgroundColor: "#684df4",
        color: "white",
        padding: "12px 36px",
        borderRadius: "8px",
        fontSize: "1.1rem",
        fontWeight: "600",
        textDecoration: "none",
        boxShadow: "0 4px 15px rgba(104, 77, 244, 0.3)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 10px 25px rgba(104, 77, 244, 0.45)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(104, 77, 244, 0.3)";
      }}
    >
      Explore Restaurant Management System →
    </Link>
  </div>
</div>
      </div>
    </div>
  );
}